import { withExtra } from '@koaly/with-extra';
import React from 'react';
import styled from 'styled-components';

const StyledDimmer = styled.div `
  position: fixed;
  background: rgba(34, 51, 52, 0.5);
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  height: 100vh;
  overflow: hidden;
  z-index: ${({ zIndex }) => zIndex};
`;
const Dimmer = withExtra(({ onClick, zIndex = 100, className }) => React.createElement(StyledDimmer, { className: className, onClick: onClick, zIndex: zIndex }), { name: 'Dimmer' });

export { Dimmer };
//# sourceMappingURL=Dimmer.js.map
